// Pure geometry for an SVG ring gauge: given a value/max, returns the
// stroke-dasharray/offset needed to fill that fraction of the circle.
// stroke-dashoffset counts DOWN from the full circumference (fully offset =
// empty ring) as the value goes up, which is why 0 -> circumference and
// max -> 0.
export function radialScoreGeometry(value, max = 100, size = 96, strokeWidth = 10) {
  const clamped = Math.max(0, Math.min(value ?? 0, max));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const ratio = max > 0 ? clamped / max : 0;
  const dashOffset = circumference * (1 - ratio);
  return { radius, circumference, dashOffset, center: size / 2 };
}

// Ring gauge with the score number in the middle — replaces the flat
// tone.bg-colored box the score used to render as (see spec §5, Übersicht).
// `color` is the existing `tone.bar` value (status color, unrelated to
// brand identity) — this component does not choose color, callers do.
export function RadialScore({ value, max = 100, size = 96, strokeWidth = 10, color, trackColor = "hsl(210,20%,92%)", children }) {
  const { radius, circumference, dashOffset, center } = radialScoreGeometry(value, max, size, strokeWidth);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={center} cy={center} r={radius} fill="none" stroke={trackColor} strokeWidth={strokeWidth} />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          style={{ transition: "stroke-dashoffset 0.4s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">{children}</div>
    </div>
  );
}
